<script setup lang="ts">
import { computed, Ref, ref, watchEffect } from 'vue'

const {
    avatar = undefined,
    name = undefined,
    icon = undefined,
    shape = 'circle',
    size = 'normal',
} = defineProps<{
    avatar?: string
    name?: string
    icon?: string
    shape?: 'circle' | 'square'
    size?: 'normal' | 'large' | 'xlarge'
}>()

const image = ref(avatar)
const label: Ref<string | undefined> = ref(undefined)

const initials = computed(() => name ? name.split(' ').map((name) => name[0]).join('') : undefined)

watchEffect(() => {
    image.value = avatar
    label.value = avatar ? undefined : initials.value
})

const onError = () => {
  // Set the label to override the image
  label.value = initials.value
  // Remove the image to show the background colour
  image.value = undefined
}
</script>

<template>
  <Avatar
    v-tooltip="{ value: name, showDelay: 500 }"
    :image="image"
    :label="label"
    :icon="icon"
    :shape="shape"
    :size="size"
    :class="{
      'bg-highlight-emphasis': avatar || name,
    }"
    @error="onError"
  />
</template>